module.exports = __webpack_public_path__ + "1791188489487/images/32px.e1d0c01.png";